/* @ngInject */
const myPiecesEditForm = (
  toaster,
  utils,
  $$piece,
  labels
) => {
  return {
    restrict: 'E',
    scope: {
      myPieces: '=',
      myWagonId: '=',
    },
    template: require('./myPiecesEditForm.html'),
    /* @ngInject */
    controller: ($scope) => {
      $scope.savePieces = async (_pieces) => {
        try {
          const response = await $$piece.request.saveAll(_pieces, $scope.myWagonId)
          toaster.message(labels.piece.log.saveAll.success(response.length))
          utils.$back()
        } catch (error) {
          toaster.error(error)
        }
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default myPiecesEditForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/piece/directives/forms/myPiecesEditForm.js